import React from 'react';
import CustomizeModal from 'components/artectum/product-details/CustomizeModal';

const QuickViewModal = ({ show, onHide, product }) => {

	return (
		<div className="ltn__modal-area ltn__quick-view-modal-area">
            <CustomizeModal product={product} isOpen={show} onRequestClose={onHide} />
		</div>
	);
};

export default QuickViewModal;